(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('g-file-laboral', {
                parent: 'entity',
                url: '/g-file-laboral?page&sort&search&code&type&nif&name&sn1&sn2&company_name',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'GFiles'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/g-file-laboral/g-files.html',
                    controller: 'GFileLaboralController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    steps: ['$stateParams', 'Step', function($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('g-file-laboral.edit', {
                parent: 'g-file-laboral',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'GFile'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/g-file-laboral/g-file-detail.html',
                        controller: 'GFileLaboralDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Administrar',
                      parent: 'g-file-laboral'
                },
                resolve: {
                    entity: ['$stateParams', 'GFile', function($stateParams, GFile) {
                        return GFile.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    processtypes: ['$stateParams', 'ProcessType', function($stateParams, ProcessType) {
                        return ProcessType.query({jurisdiction: 'LABORAL'}).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'g-file',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('g-file-laboral.new', {
                parent: 'g-file-laboral',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/g-file-laboral/g-file-new.html',
                    controller: 'GFileLaboralNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'g-file-laboral'
                },
                resolve: {
                    entity: function() {
                        return {
                            code: null,
                            id: null
                        };
                    },
                    processtypes: ['$stateParams', 'ProcessType', function($stateParams, ProcessType) {
                        return ProcessType.query({jurisdiction: 'LABORAL'}).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'g-file',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            });
    }

})();
